/**
 * Ajuda detalhada por tela: campo a campo, botão a botão. Indexado pela
 * pathname exata da rota (useLocation().pathname). Conteúdo verificado
 * contra o código real de cada tela — nunca invente um campo/regra sem
 * confirmar no componente/controller correspondente.
 *
 * Telas sem entrada aqui mostram um placeholder "ainda não escrita" no
 * DetailedHelpPanel — não é erro, é conteúdo pendente.
 *
 * O conteúdo é escrito em vários arquivos por domínio (help-content/*.ts)
 * pra permitir trabalho paralelo sem dois arquivos colidindo. `mergeHelpMaps`
 * CONCATENA as seções de cada rota em vez de sobrescrever — dois arquivos
 * diferentes podem adicionar conteúdo pra mesma rota (ex.: um arquivo cobre
 * a lista de /reservas, outro cobre o modal de detalhe que abre por cima
 * da mesma rota) sem um apagar o outro.
 */
import type { DetailedHelpMap, DetailedHelpSection } from "./help-content/types";
import { OPERACAO_HOSPEDES_HELP } from "./help-content/operacaoHospedes";
import { GESTAO_OPERACIONAL_HELP } from "./help-content/gestaoOperacional";
import { GESTAO_COMERCIAL_HELP } from "./help-content/gestaoComercial";
import { RESERVAS_AVANCADO_HELP } from "./help-content/reservasAvancado";
import { ADMINISTRACAO_HELP } from "./help-content/administracao";
import { CONFIGURACOES_HELP } from "./help-content/configuracoes";

export type { DetailedHelpItem, DetailedHelpSection } from "./help-content/types";

function mergeHelpMaps(...maps: DetailedHelpMap[]): DetailedHelpMap {
  const merged: Record<string, DetailedHelpSection[]> = {};
  for (const map of maps) {
    for (const [path, sections] of Object.entries(map)) {
      merged[path] = [...(merged[path] ?? []), ...sections];
    }
  }
  return merged;
}

export const DETAILED_HELP_CONTENT: DetailedHelpMap = mergeHelpMaps(
  OPERACAO_HOSPEDES_HELP,
  GESTAO_OPERACIONAL_HELP,
  GESTAO_COMERCIAL_HELP,
  RESERVAS_AVANCADO_HELP,
  ADMINISTRACAO_HELP,
  CONFIGURACOES_HELP,
);
